import { APP_NETWORKS_SUPPORT } from 'connectors/constants';
import WALLET_STATUS from 'constants/walletStatus';

declare let window: any;

export const setupNetwork = async (chainId?: number) => {
  const provider = window.ethereum ?? null;
  if (provider) {
    try {
      const networkInfo = APP_NETWORKS_SUPPORT[Number(chainId)];
      if (networkInfo) {
        try {
          await provider.request({
            method: 'wallet_switchEthereumChain',
            params: [{ chainId: networkInfo.details?.chainId }],
          });
        } catch (error: any) {
          //Reject metamask
          if (WALLET_STATUS.CANCEL_METAMASK === error?.code || WALLET_STATUS.ACTION_REJECTED === error?.code) {
            return;
          }

          // This error code indicates that the chain has not been added to MetaMask.
          if (WALLET_STATUS.NOT_EXISTED_NETWORK === error?.code) {
            try {
              await provider.request({
                method: 'wallet_addEthereumChain',
                params: [
                  {
                    ...(networkInfo.details || {}),
                  },
                ],
              });
            } catch (addError) {
              return false;
            }
          } else {
            return false;
          }
        }
      } else return false;
    } catch (e) {
      return false;
    }
  } else {
    return false;
  }
};
